export default __webpack_public_path__ + "static/media/instrucciones.60cde334.png";